var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRenewalsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 4.99967V7.49967L13.3335 4.16634L10.0002 0.833008V3.33301C8.23205 3.33301 6.53636 4.03539 5.28612 5.28563C4.03588 6.53587 3.3335 8.23156 3.3335 9.99967C3.3335 11.308 3.71683 12.5247 4.36683 13.5497L5.5835 12.333C5.2085 11.6413 5.00016 10.833 5.00016 9.99967C5.00016 8.67359 5.52695 7.40182 6.46463 6.46414C7.40231 5.52646 8.67408 4.99967 10.0002 4.99967ZM15.6335 6.44967L14.4168 7.66634C14.7835 8.36634 15.0002 9.16634 15.0002 9.99967C15.0002 11.3258 14.4734 12.5975 13.5357 13.5352C12.598 14.4729 11.3262 14.9997 10.0002 14.9997V12.4997L6.66683 15.833L10.0002 19.1663V16.6663C11.7683 16.6663 13.464 15.964 14.7142 14.7137C15.9645 13.4635 16.6668 11.7678 16.6668 9.99967C16.6668 8.69134 16.2835 7.47467 15.6335 6.44967Z",
    fill: "#C7222A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenewalsIcon);
export default __webpack_public_path__ + "static/media/renewals-icon.c641fcf729902ccc4f7c493158943c8c.svg";
export { ForwardRef as ReactComponent };